import { Badge } from "../../../stores/BadgeStore/Types";
import { CourseResource } from "../../../stores/CoursesStore/Types";

export interface CourseBadgeGroup {
  courseId: number | string;
  courseName: string;
  courseImageUrl?: string;
  badges: Badge[];
}

export const earnedBadges = (badges: Badge[]) =>
  badges.filter((badge) => badge.persisted);

export const progressPercent = (earned: number, total: number) => {
  if (total === 0) return 0;

  return Math.round((earned / total) * 100);
};

export const courseImageUrl = (badge: Badge) =>
  badge.enrolment?.course?.preview_masthead_image_url ||
  badge.enrolment?.course?.masthead_image_url ||
  (
    badge.enrolment?.course as typeof badge.enrolment.course & {
      checkout_image?: string;
    }
  )?.checkout_image;

export const dashboardCourseImageUrl = (course: CourseResource) =>
  course.preview_masthead_image_url ||
  course.masthead_image_url ||
  course.preview_masthead_alt_image_url;

export const courseUrl = (course: CourseResource) =>
  course.course_path || `/courses/${course.slug}`;

export interface BadgeDialogContent {
  earned: boolean;
  title: string;
  message: string;
  imageUrl?: string;
  courseName?: string;
  enrolHref?: string;
  enrolLabel?: string;
}

export const badgeDialogContent = (badge: Badge): BadgeDialogContent => {
  const earned = badge.persisted;

  return {
    earned,
    title: badge.badge_name,
    message: earned ? badge.badge_awarded_message : badge.badge_unawarded_instruction,
    imageUrl: earned ? badge.badge_url : undefined,
    courseName:
      badge.scoped && badge.enrolment?.course
        ? badge.enrolment.course.name
        : undefined,
  };
};

export const lockedCourseDialogContent = (
  course: CourseResource,
): BadgeDialogContent => ({
  earned: false,
  title: "Locked",
  message: `To earn this badge, enrol in the ${course.name} course.`,
  courseName: course.name,
  enrolHref: courseUrl(course),
  enrolLabel: `Enrol in ${course.name}`,
});
